export default "{\n    \"label\": \"Incidente en curso\",\n    \"options\": {\n        \"true\": \"Tiene incidente en curso\"\n    }\n}\n"